import { render, staticRenderFns } from "./TextSlot.vue?vue&type=template&id=30960c4d&scoped=true&"
import script from "./TextSlot.vue?vue&type=script&lang=ts&"
export * from "./TextSlot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30960c4d",
  null
  
)

export default component.exports